// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1MkuO","upload":"Small_upload__2H8ep","imageWrap":"Small_imageWrap__2BW45","removeBtn":"Small_removeBtn__3yOmL"};